/* Colostrum graph layout (ported from the mock's layoutChart): dashed separator between bar 1 and 2, the spanning drop
   callout over bars 2-4 (arrow shaft = 45% of the plot), bracket widths. Optional grow-on-scroll (setting). */
(() => {
  function layout(root) {
    const plot = root.querySelector('[data-sm-plot]');
    if (!plot) return;
    const cols = [...plot.querySelectorAll('.col')];
    if (cols.length < 2) return;
    const pr = plot.getBoundingClientRect();
    const r1 = cols[0].getBoundingClientRect(), r2 = cols[1].getBoundingClientRect(), rL = cols[cols.length - 1].getBoundingClientRect();
    const sep = root.querySelector('[data-sm-sep]');
    if (sep) sep.style.left = ((r1.right + r2.left) / 2 - pr.left - 1) + 'px';
    const dc = root.querySelector('[data-sm-dcall]');
    if (dc) {
      dc.style.left = (r2.left - pr.left) + 'px';
      dc.style.width = (rL.right - r2.left) + 'px';
      const shaft = dc.querySelector('.bigarr .shaft');
      if (shaft) shaft.style.height = Math.round(pr.height * 0.45) + 'px';
    }
    const bk = root.querySelector('[data-sm-brk]');
    if (bk) {
      const b1 = bk.querySelector('.bk1'), b2 = bk.querySelector('.bk2');
      b1.style.width = (r1.width + 12) + 'px'; b1.style.marginLeft = '-6px'; b1.style.flex = '0 0 auto';
      b2.style.flex = '1'; b2.style.marginLeft = (r2.left - r1.right - 16 - 12 + 6) + 'px';
      const br = bk.getBoundingClientRect();
      if (sep) sep.style.height = (br.bottom - pr.top + 6) + 'px';
    }
  }
  function init(root) {
    const run = () => layout(root);
    run();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
    let t; window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(run, 100); }, { passive: true });
    if (root.classList.contains('sm-anim')) {
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { root.classList.add('is-in'); return; }
      const io = new IntersectionObserver((entries) => { entries.forEach((e) => { if (e.isIntersecting) { root.classList.add('is-in'); io.disconnect(); } }); }, { threshold: 0.35 });
      io.observe(root.querySelector('[data-sm-plot]') || root);
    }
  }
  const all = () => document.querySelectorAll('[data-sm-graph]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
